import React from 'react';
import { Container, Grow, Grid, Typography, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import useStyles from './styles';
import illustration from '../../assets/others/flare_illustration.png';
import AGB_img from '../../assets/support company/AGB.png';
import ICHIGO_img from '../../assets/support company/ICHIGO.png';
import LEAVEANET_img from '../../assets/support company/leave_a_nest.png';
import Patagonia_img from '../../assets/support company/Patagonia.png';
import KYOTANGO_img from '../../assets/support company/kyotango.png';
import ourFuture from '../../assets/others/our_future.jpg';
import community_icon from '../../assets/logo/community_icon.png';
import company_icon from '../../assets/logo/company_icon.png';
import project_support_icon from '../../assets/logo/project_support_icon.png';
import useCommonStyles from '../CommonStyle/commonStyle';
import community_img from '../../assets/tab section/community.png';
import company_img from '../../assets/tab section/company.png';
import search_img from '../../assets/tab section/search.png';
// import useMedia from "use-media";
import GoToTop from '../Functional/GoToTop';
import PopModal from '../PopModal/PopModal';



// function useQuery() {
//     return new URLSearchParams(useLocation().search);
// }

const LandingEnt = () => {

    const classes = useStyles();
    const commonClasses = useCommonStyles();
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
    };
    const { innerWidth: width, innerHeight: height } = window;
    const minWidth = 830;
    let isLarger830 = true;
    minWidth<width ? isLarger830 = true: isLarger830 = false;
    // const isLarger830 = innerWidth>830;
    // const isLarger830 = useMedia({ minWidth: "830px" });
    // const isLarger830 = true;

    function FlareCanContent(props: { iconImg: string; title: string; body: string; mainImg: string; }) {
        return <Container className={classes.flareCanContainer}>
            <div className={classes.flareCanIconDiv}>
                <img src={props.iconImg} className={classes.flareCanIcon} alt="FlareCan" />
                <Container className={classes.flareCanPartition}> </Container>
                <div>
                    <Typography className={classes.flareCanMainText} >
                        {props.title}
                    </Typography>
                    <Typography className={classes.flareCanSubText} >
                        {props.body}
                    </Typography>
                </div>
            </div>
            <img src={props.mainImg} alt="placeholder" className={classes.flareCanImg} />
            
        </Container>;
    }
    function FlareCanContentMobile(props: { iconImg: string; title: string; body: string; mainImg: string; }) {
        return <Container className={classes.flareCanContainerSmall}>
            <img src={props.mainImg} alt="placeholder" className={classes.flareCanImgSmall} />
            <div className={classes.flareCanIconDivSmall}>
                <img src={props.iconImg} alt="community_icon" className={classes.flareCanIconSmall} />
                <Container className={classes.flareCanPartitionSmall}> </Container>
                <Typography className={classes.flareCanMainTextSmall} >
                    {props.title}
                </Typography>
            </div>
            <Typography className={classes.flareCanSubTextSmall} >
                {props.body}
            </Typography>
            <GoToTop />
        </Container>;
    }
    return (
        <Grow in>
            <Container maxWidth="lg" className={commonClasses.bodyContainer}>
                <Grid container direction="row" justifyContent="space-between" alignItems="stretch" spacing={3} className={classes.topGridContainer}>
                    <Grid item xs={12} sm={6} md={6} className={classes.leftGrid}>

                        <Typography component={'span'} variant="h5" className={classes.smallTopTitle}>
                            未成年との共創をご検討中の企業様へ
                        </Typography >
                        <br />
                        <br />
                        <Typography component={'span'} variant="h2" className={classes.motivationalTitle} >
                            世界を<br />変えよう<br />みんなの力で<br />
                        </Typography>
                        <br />
                        <br />
                        <Typography component={'span'} variant="h6" className={classes.smallTitle}>
                            社会問題を解決したい未成年が、<br></br>共創したい企業と出会えるプラットフォーム。
                        </Typography >

                        <br />
                        {/* <Button component={Link} to="/" className={classes.documentButton}>資料請求はこちら</Button> */}
                        {
                            process.env.REACT_APP_STAGE !== 'prod' ? (
                                <>
                                    <Button component={Link} to="/enterprise/signup" className={classes.signupButton}>企業用新規登録</Button>
                                    {/* <Button component={Link} to="/startup/login" className={classes.loginButton}>ログイン</Button> */}
                                </>
                            ) : (
                                <>
                                    <Button component={Link} to="#" className={classes.signupButton} onClick={handleOpen}>企業新規登録</Button>
                                    {/* <Button component={Link} to="#" className={classes.loginButton} onClick={handleOpen}>ログイン</Button> */}
                                    <PopModal setOpen={setOpen} open={open} />
                                </>)
                        }
                        <Button href="https://www.sustainablegame.com/?page_id=210" className={classes.documentButton}>資料請求はこちら</Button>
                    </Grid>
                    <Grid container item xs={12} sm={6} md={6}>
                        <img src={illustration} width="600"  alt="Illustration"></img>
                    </Grid>

                </Grid>
                <div className={classes.partnerSection}>
                    <Typography component={'span'} variant="h5" className={classes.sectionTitle} >
                        Flare Partner
                    </Typography>
                    <br />
                    <Typography className={classes.sectionSubTitle}>
                        広がる共感の輪
                    </Typography>
                    <br />
                    <Grid container direction="row" justifyContent="space-evenly" spacing={3} className={classes.sponsorDiv}>
                        <Grid item>
                            <img className={classes.sponsorLogos} src={ICHIGO_img} alt="Ichigo"/>
                        </Grid>
                        <Grid item>
                            <img className={classes.sponsorLogos} src={LEAVEANET_img} alt="Leaveanet" />
                        </Grid>
                        <Grid item>
                            <img className={classes.sponsorLogos} src={Patagonia_img} alt="Patagonia" />
                        </Grid>
                        <Grid item>
                            <img className={classes.sponsorLogos} src={KYOTANGO_img} alt="Kyotango" />
                        </Grid>
                    </Grid>
                </div>
                <div className={classes.ourFutureSection}>
                    <Typography component={'span'} variant="h5" className={classes.sectionTitle} >
                        <span className={commonClasses.wrapSpan}>私たちが</span>
                        <span className={commonClasses.wrapSpan}>つくりたい未来</span>

                    </Typography>
                    <br />
                    <Typography className={classes.sectionSubTitle}>
                        あたらしい未成年と企業の共創で社会問題を解決する。
                    </Typography>
                    <br />
                    <div className={classes.ourFutureImageDiv}>
                        <img src={ourFuture} alt="our_future" className={classes.ourFutureImage} />
                    </div>
                </div>
                
                <div className={classes.flareCanSection}>
                    <Typography component={'span'} variant="h5" className={classes.sectionTitle} >
                        <span className={commonClasses.wrapSpan}>Flareで</span>
                        <span className={commonClasses.wrapSpan}>出来ること</span>
                    </Typography>
                    <br />
                    {isLarger830 ?
                        <>
                            <FlareCanContent title='持続可能な社会に向けた探究' body='未来のステークホルダーとの接点を増やす事で、これからの事業の方向性や会社のパーパスを探究できます。' iconImg={community_icon} mainImg={community_img} />

                            <FlareCanContent title='未成年との共創に特化したプラットフォーム' body=' 実際に様々な未成年と企業の共創実績を持つSustainableGameのノウハウを活かし、社会問題の解決を目指す新進気鋭な未成年と企業による共創への一歩目をサポートします。' iconImg={company_icon} mainImg={search_img} />

                            <FlareCanContent title='安心安全で持続的な関係性の構築をサポート' body='弁護士をはじめとする様々な専門家にご参画いただき、安心安全でフェアな共創関係を構築できる体制を築く事で、未成年と企業が持続的に共創プロジェクトを行えるようサポートします。' iconImg={project_support_icon} mainImg={company_img} />
                        </> : <>
                            <FlareCanContentMobile title='持続可能な社会に向けた探究' body='未来のステークホルダーとの接点を増やす事で、これからの事業の方向性や会社のパーパスを探究できます。' iconImg={community_icon} mainImg={community_img} />

                            <FlareCanContentMobile title='未成年との共創に特化したプラットフォーム' body=' 実際に様々な未成年と企業の共創実績を持つSustainableGameのノウハウを活かし、社会問題の解決を目指す新進気鋭な未成年と企業による共創への一歩目をサポートします。' iconImg={company_icon} mainImg={search_img} />

                            <FlareCanContentMobile title='安心安全で持続的な関係性の構築をサポート' body='弁護士をはじめとする様々な専門家にご参画いただき、安心安全でフェアな共創関係を構築できる体制を築く事で、未成年と企業が持続的に共創プロジェクトを行えるようサポートします。' iconImg={project_support_icon} mainImg={company_img} />

                        </>}
                    <div className={classes.moreWhatWeCanDiv}>
                        {/* <Button component={Link} to="/" className={classes.documentButton}>事例はこちら</Button> */}
                        <Button href="https://www.sustainablegame.com" className={classes.documentButton}>事例はこちら</Button>
                    </div>
            
                </div>
                <GoToTop />
            </Container>
        </Grow>
    )

};
export default LandingEnt;